import axios from 'axios';

// internal
import { endpoint, headers } from '@app/utils/service';
import {
  FetchWithZone,
  FetchCreate,
  FetchDelete,
  FetchById,
  FetchUpdate,
  SyncDevice,
  FetchWithProject,
} from '@app/typings/services/device.d';
import { getRowsPerPage } from '@app/utils/localStorage';

export const fetchWithZone: FetchWithZone = (project, zone, option) => {
  return axios({
    url: endpoint('/devices'),
    method: 'GET',
    params: {
      projectId: project,
      zoneId: zone,
      offset: option?.offset || 0,
      limit: option?.limit || Number(getRowsPerPage()),
      name: option?.name,
      deviceType: option?.deviceType,
    },
    ...headers(),
  });
};

export const fetchWithProject: FetchWithProject = (project) => {
  return axios({
    url: endpoint('/devices'),
    method: 'GET',
    params: {
      projectId: project,
    },
    ...headers(),
  });
};

export const fetchById: FetchById = (id) => {
  return axios({
    url: endpoint(`/devices/${id}`),
    ...headers(),
  });
};

export const fetchCreate: FetchCreate = (data) => {
  return axios({
    url: endpoint('/devices'),
    method: 'POST',
    data: {
      type: data.type,
      name: data.name,
      zoneId: data.zone,
      lockerIds: data.lockers,
    },
    ...headers(),
  });
};

export const fetchDelete: FetchDelete = (id) => {
  return axios({
    url: endpoint(`/devices/${id}`),
    method: 'DELETE',
    ...headers(),
  });
};

export const fetchUpdate: FetchUpdate = (id, data) => {
  return axios({
    url: endpoint(`/devices/${id}`),
    method: 'PATCH',
    data: {
      type: data.type,
      name: data.name,
      lockerIds: data.lockers,
    },
    ...headers(),
  });
};

export const syncDevice: SyncDevice = (projectId, types) => {
  return axios({
    url: endpoint(`/devices/sync-devices`),
    method: 'POST',
    data: {
      projectId,
      types,
    },
    ...headers(),
  });
};
